//배포 URL은 셋팅하기
const getApiUrl = () => {
    if (process.env.REACT_APP_NODE_ENV === 'development') {
      return 'http://localhost:3000';
    }
    return 'https://pms.idpass.kr';
  };
  
  export const API_URL = getApiUrl();
